$(document).ready(function () {
    if (!$('.candidate-portal__cv-form').length && !$('.candidate-portal__cv-creator').length) {
        return;
    }

    var base_url = $('#base_url').val();
    var template_directory = $('#template_directory').val();

    // Initialize Materialize Components for Navbar
    // Dropdown menus
    $('.dropdown-trigger').dropdown({
        hover: true,
        coverTrigger: false,
        constrainWidth: false
    });

    // Mobile Sidenav
    $('.sidenav').sidenav({
        edge: 'right',
        draggable: true
    });

    // Collapsible menus in sidenav
    $('.collapsible').collapsible();

    // Initialize Materialize Tooltips
    var tooltipElems = document.querySelectorAll('.tooltipped');
    M.Tooltip.init(tooltipElems, {
        position: 'top',
        enterDelay: 200,
        exitDelay: 0,
        margin: 5,
        inDuration: 300,
        outDuration: 250,
        transitionMovement: 10
    });

    function setupToggle(iconId, inputId) {
        $('#' + iconId).off('click').on('click', function () {
            const $input = $('#' + inputId);
            const isPasswordVisible = $input.attr('type') === 'text';
            $input.attr('type', isPasswordVisible ? 'password' : 'text');
            $(this).text(isPasswordVisible ? 'visibility_off' : 'visibility');
        });
    }

    
    setupToggle('togglePassword', 'password');
    setupToggle('toggleConfirmPassword', 'confirm_password');    

    $('#global-loader').hide();

    function cvcreatorSetPortfolioUrlErrorState(num, isInvalid) {
        var $input = $('#url_' + num);
        if (!$input.length) {
            return;
        }
        var $wrap = $input.closest('.input-field');
        var $err = $wrap.find('.portfolio-url-error');
        if (!$err.length) {
            $err = $('<span class="portfolio-url-error" role="alert"></span>');
            $wrap.append($err);
        }
        if (isInvalid) {
            $input.addClass('invalid');
            $input.attr('aria-invalid', 'true');
            $err.html('Usa una URL con <strong>dominio completo</strong> (ej. <strong>https://gitlab.com/usuario</strong> — con extensión .com, .mx, etc.).');
        } else {
            $input.removeClass('invalid');
            $input.removeAttr('aria-invalid');
            $err.empty();
        }
    }

    function cvcreatorSetPortfolioPlatformErrorState(num, isInvalid) {
        var $sel = $('#platform_' + num);
        if (!$sel.length) {
            return;
        }
        var $wrap = $sel.closest('.input-field');
        var $err = $wrap.find('.portfolio-platform-error');
        if (!$err.length) {
            $err = $('<span class="portfolio-platform-error" role="alert"></span>');
            $wrap.append($err);
        }
        if (isInvalid) {
            $sel.addClass('invalid');
            $sel.attr('aria-invalid', 'true');
            $err.html('Selecciona una <strong>plataforma o tecnología</strong> en la lista.');
        } else {
            $sel.removeClass('invalid');
            $sel.removeAttr('aria-invalid');
            $err.empty();
        }
    }

    function cvcreatorSyncPortfolioLinkPair(num) {
        var rawUrl = String($('#url_' + num).val() || '').trim();
        var platRaw = $('#platform_' + num).val();
        var plat = platRaw === null || platRaw === undefined ? '' : String(platRaw).trim();
        var needsPlatform = rawUrl !== '' && plat === '';
        cvcreatorSetPortfolioPlatformErrorState(num, needsPlatform);
        var badUrl = !cvcreatorIsValidPortfolioUrl(rawUrl);
        cvcreatorSetPortfolioUrlErrorState(num, badUrl && rawUrl !== '');
    }

    function cvcreatorSyncPortfolioUrlFieldFromInput($field) {
        var id = ($field.attr('id') || '');
        var m = /^url_(\d+)$/.exec(id);
        if (!m) {
            return;
        }
        cvcreatorSyncPortfolioLinkPair(parseInt(m[1], 10));
    }

    function cvcreatorNormalizePortfolioUrlFieldFromInput($field) {
        var id = ($field.attr('id') || '');
        var m = /^url_(\d+)$/.exec(id);
        if (!m) {
            return;
        }
        var normalized = cvcreatorNormalizeUrlValue($field.val());
        if (($field.val() || '').trim() !== normalized) {
            $field.val(normalized);
        }
    }

    $(document).on('input', 'input[id^="url_"]', function () {
        cvcreatorSyncPortfolioUrlFieldFromInput($(this));
    });
    $(document).on('paste cut', 'input[id^="url_"]', function () {
        var $field = $(this);
        setTimeout(function () {
            cvcreatorSyncPortfolioUrlFieldFromInput($field);
        }, 0);
    });
    $(document).on('blur', 'input[id^="url_"]', function () {
        var $field = $(this);
        cvcreatorNormalizePortfolioUrlFieldFromInput($field);
        cvcreatorSyncPortfolioUrlFieldFromInput($field);
    });
    $(document).on('change', 'select[id^="platform_"]', function () {
        var sid = ($(this).attr('id') || '');
        var pm = /^platform_(\d+)$/.exec(sid);
        if (!pm) {
            return;
        }
        cvcreatorSyncPortfolioLinkPair(parseInt(pm[1], 10));
    });

    /* Ultimo valor valido por ranura de enlace; si el URL actual es invalido, el PDF usa este snapshot y el resto del formulario sigue actualizando. */
    var portfolioPdfLastSent = {};

    function cvcreatorInitPortfolioPdfLastSentFromDom() {
        var ip;
        portfolioPdfLastSent = {};
        for (ip = 1; ip <= 10; ip++) {
            if (!$('#url_' + ip).length) {
                continue;
            }
            var $urlInput = $('#url_' + ip);
            var u = cvcreatorNormalizeUrlValue($urlInput.val());
            if (($urlInput.val() || '').trim() !== u) {
                $urlInput.val(u);
            }
            var plat = ($('#platform_' + ip).val() || '').trim();
            var plid = ($('#portfolio_links_id_' + ip).val() || '').trim();
            if (cvcreatorIsValidPortfolioUrl(u) && plat !== '') {
                portfolioPdfLastSent[ip] = {
                    url: u,
                    platform: plat,
                    portfolio_links_id: plid
                };
            } else if (u === '') {
                portfolioPdfLastSent[ip] = {
                    url: '',
                    platform: plat,
                    portfolio_links_id: plid
                };
            }
        }
    }

    function cvcreatorApplyPortfolioFieldsForPdf(fields) {
        var ip;
        for (ip = 1; ip <= 10; ip++) {
            if (!$('#url_' + ip).length) {
                continue;
            }
            var pidKey = 'portfolio_links_id_' + ip;
            var platKey = 'platform_' + ip;
            var urlKey = 'url_' + ip;
            var $urlInput = $('#url_' + ip);
            var u = cvcreatorNormalizeUrlValue($urlInput.val());
            if (($urlInput.val() || '').trim() !== u) {
                $urlInput.val(u);
            }
            var plat = ($('#platform_' + ip).val() || '').trim();
            var plid = ($('#portfolio_links_id_' + ip).val() || '').trim();
            if (u === '') {
                fields[pidKey] = plid;
                fields[platKey] = plat;
                fields[urlKey] = '';
                portfolioPdfLastSent[ip] = {
                    url: '',
                    platform: plat,
                    portfolio_links_id: plid
                };
            } else if (plat === '') {
                var snapPl = portfolioPdfLastSent[ip];
                if (snapPl) {
                    fields[pidKey] = snapPl.portfolio_links_id;
                    fields[platKey] = snapPl.platform;
                    fields[urlKey] = snapPl.url;
                } else {
                    fields[pidKey] = plid;
                    fields[platKey] = '';
                    fields[urlKey] = '';
                }
            } else if (cvcreatorIsValidPortfolioUrl(u)) {
                fields[pidKey] = plid;
                fields[platKey] = plat;
                fields[urlKey] = u;
                portfolioPdfLastSent[ip] = {
                    url: u,
                    platform: plat,
                    portfolio_links_id: plid
                };
            } else {
                var snap = portfolioPdfLastSent[ip];
                if (snap) {
                    fields[pidKey] = snap.portfolio_links_id;
                    fields[platKey] = snap.platform;
                    fields[urlKey] = snap.url;
                } else {
                    fields[pidKey] = plid;
                    fields[platKey] = plat;
                    fields[urlKey] = '';
                }
            }
        }
    }

    function loadPDFMiniViewers(baseUrl, callback) {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/css/main.css';
        document.head.appendChild(css);

        const script1 = document.createElement('script');
        script1.src = base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf.js';
        script1.onload = function () {
            const script2 = document.createElement('script');
            script2.src = base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf-viewer.js';
            script2.onload = callback;
            document.body.appendChild(script2);
        };
        document.body.appendChild(script1);
    }

    // fitPDFInViewer() eliminado: pdf-viewer.js ya aplica fit-by-width de forma nativa
    // y el CSS maneja overflow-y: auto para scroll. Aplicar transform adicional
    // causaba doble reducción de escala haciendo el PDF demasiado pequeño.

    /**
     * Fix navegación de páginas en el PDF viewer.
     *
     * pdf-viewer.js usa element.scrollIntoView() que mueve tanto el .pdf-viewer
     * como el window, causando un desplazamiento extraño. La solución es parchear
     * Element.prototype.scrollIntoView para que, cuando el elemento esté dentro
     * del .pdf-viewer, use viewer.scrollTop en lugar de scrollIntoView nativo.
     * Esto intercepta la llamada ANTES de que inicie cualquier animación.
     */
    function fixPDFPageNavigation() {
        var originalScrollIntoView = Element.prototype.scrollIntoView;

        Element.prototype.scrollIntoView = function (options) {
            var viewer = document.querySelector('.pdf-viewer');
            // Solo interceptar si el elemento es una página dentro del pdf-viewer
            if (viewer && viewer.contains(this) && this.dataset && this.dataset.pageNumber) {
                // Calcular posición relativa al viewer usando getBoundingClientRect
                var pageRect   = this.getBoundingClientRect();
                var viewerRect = viewer.getBoundingClientRect();
                viewer.scrollTop += pageRect.top - viewerRect.top;
                return;
            }
            // Para cualquier otro elemento, comportamiento normal
            originalScrollIntoView.call(this, options);
        };
    }

window.pagesense = window.pagesense || [];

(function ($, w, d) {
  function psReady() {
    return typeof w.pagesense?.push === 'function' &&
           $('script[src*="pagesense"]').length > 0;
  }

  $.psEmit = function (name, opts) {
    var o = $.extend({ onceKey: null, retries: 15, delay: 200 }, opts || {});
    var dfd = $.Deferred();

    if (o.onceKey) {
      var k = 'ps_once_' + o.onceKey;
      try {
        if (sessionStorage.getItem(k)) return dfd.resolve().promise();
        sessionStorage.setItem(k, '1');
      } catch (_) {}
    }

    if (psReady()) {
      w.pagesense.push(['trackEvent', name]);
      return dfd.resolve().promise();
    }

    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (psReady()) {
        clearInterval(t);
        w.pagesense.push(['trackEvent', name]);
        dfd.resolve();
      } else if (tries >= o.retries) {
        clearInterval(t);
        console.warn('PageSense no estuvo listo para:', name);
        dfd.reject();
      }
    }, o.delay);

    return dfd.promise();
  };
})(jQuery, window, document);

    // CV Form
    if ($('.candidate-portal__cv-form').length) {
        cvcreatorInitPortfolioPdfLastSentFromDom();
        (function () {
            var i;
            for (i = 1; i <= 10; i++) {
                if ($('#url_' + i).length) {
                    cvcreatorSyncPortfolioLinkPair(i);
                }
            }
        })();
        Simditor.locale = 'en-US';

        const saveButton = document.getElementById("saveButton");
        const overlay = document.getElementById("savingOverlay");

        //Init Modal - CV Creator Download (for form page)
        $('#modal-cv-creator-download').modal({
            dismissible: true,
            preventScrolling: true,
            onOpenStart: function () {
                // Show Step 1, hide Step 2
                $('.cv-creator-download .modal-cv-creator-download .step_1').show();
                $('.cv-creator-download .modal-cv-creator-download .step_2').hide();
            }
        });

        /*
        Paths can be relative or absolute but should be on the same server:
        path/to/pdf-worker.js ==> Tell PMV where pdf-worker.js is located
        path/to/cmaps         ==> Tell PMV where the CMAP folder is located.
        */
        const input = document.querySelector("#mobile");
        window.intlTelInput(input, {
            countryOrder: ["mx","us"],
            initialCountry: "mx",
            hiddenInput: () => ({ phone: "full_phone", country: "country_code" }),
            strictMode: true,
            i18n: {
                // Aria label for the selected country element
                selectedCountryAriaLabel: "País seleccionado",
                // Screen reader text for when no country is selected
                noCountrySelected: "No se ha seleccionado país",
                // Aria label for the country list element
                countryListAriaLabel: "Lista de países",
                // Placeholder for the search input in the dropdown
                searchPlaceholder: "Buscar",
                // Screen reader text for when the search produces no results
                zeroSearchResults: "No se encontraron resultados",
                // Screen reader text for when the search produces 1 result
                oneSearchResult: "1 resultado encontrado",
                // Screen reader text for when the search produces multiple results, where ${count} will be replaced by the count
                multipleSearchResults: "${count} resultados encontrados",
            },
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.1.0/build/js/utils.js",
        });
        const iti = intlTelInput.getInstance(input);
        
        /** RESUME EDITOR **/
        var resume_editor = new Simditor({
            textarea: $('#professional_summary'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        resume_editor.on('valuechanged', function(e, src) {
            var resume = resume_editor.getValue();
            var counter = resume.length;
            $('.resume_counter').text(counter + '/330');
            if (counter > 330) {
                $('.resume_counter').css('color', 'red');
            } else {
                $('.resume_counter').css('color', 'black');
            }
        });

        resume_editor.on('blur', function(e, src) {
            processPDF('professional_summary');
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 1 **/
        var description_1_editor = new Simditor({
            textarea: $('#description_1'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_1_editor.on('valuechanged', function(e, src) {
            var description = description_1_editor.getValue();
            var description_counter = description.length;
            $('.description_1_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_1_counter').css('color', 'red');
            } else {
                $('.description_1_counter').css('color', 'black');
            }
        });

        description_1_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_1 = $('#end_date_month_1').val();
            end_date_year_1 = $('#end_date_year_1').val();
            if (end_date_month_1 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_1 != '') { end_date = true; }
            }

            if (
                $('#occupation_title_1').val() != '' &&
                $('#company_1').val() != '' &&
                $('#start_date_month_1').val() != null &&
                $('#start_date_year_1').val() != null &&
                $('#end_date_month_1').val() != null &&
                end_date &&
                description_1_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 2 **/
        var description_2_editor = new Simditor({
            textarea: $('#description_2'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_2_editor.on('valuechanged', function(e, src) {
            var description = description_2_editor.getValue();
            var description_counter = description.length;
            $('.description_2_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_2_counter').css('color', 'red');
            } else {
                $('.description_2_counter').css('color', 'black');
            }
        });

        description_2_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_2 = $('#end_date_month_2').val();
            end_date_year_2 = $('#end_date_year_2').val();
            if (end_date_month_2 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_2 != '') { end_date = true; }
            }

            if (
                $('#occupation_title_2').val() != '' &&
                $('#company_2').val() != '' &&
                $('#start_date_month_2').val() != null &&
                $('#start_date_year_2').val() != null &&
                $('#end_date_month_2').val() != null &&
                end_date &&
                description_2_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 3 **/
        var description_3_editor = new Simditor({
            textarea: $('#description_3'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_3_editor.on('valuechanged', function(e, src) {
            var description = description_3_editor.getValue();
            var description_counter = description.length;
            $('.description_3_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_3_counter').css('color', 'red');
            } else {
                $('.description_3_counter').css('color', 'black');
            }
        });

        description_3_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_2 = $('#end_date_month_2').val();
            end_date_year_2 = $('#end_date_year_2').val();
            if (end_date_month_2 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_2 != '') { end_date = true; }
            }
            
            if (
                $('#occupation_title_3').val() != '' &&
                $('#company_3').val() != '' &&
                $('#start_date_month_3').val() != null &&
                $('#start_date_year_3').val() != null &&
                $('#end_date_month_3').val() != null &&
                end_date &&
                description_3_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 4 **/
        var description_4_editor = new Simditor({
            textarea: $('#description_4'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_4_editor.on('valuechanged', function(e, src) {
            var description = description_4_editor.getValue();
            var description_counter = description.length;
            $('.description_4_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_4_counter').css('color', 'red');
            } else {
                $('.description_4_counter').css('color', 'black');
            }
        });

        description_4_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_4 = $('#end_date_month_4').val();
            end_date_year_4 = $('#end_date_year_4').val();
            if (end_date_month_4 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_4 != '') { end_date = true; }
            }
            
            if (
                $('#occupation_title_4').val() != '' &&
                $('#company_4').val() != '' &&
                $('#start_date_month_4').val() != null &&
                $('#start_date_year_4').val() != null &&
                $('#end_date_month_4').val() != null &&
                end_date &&
                description_4_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        /** DESCRIPTION PROFESSIONAL EXPERIENCE EDITOR 5 **/
        var description_5_editor = new Simditor({
            textarea: $('#description_5'),
            placeholder: '',
            upload: false,
            cleanPaste: true,
            pasteImage: false,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
        });

        description_5_editor.on('valuechanged', function(e, src) {
            var description = description_5_editor.getValue();
            var description_counter = description.length;
            $('.description_5_counter').text(description_counter + '/556');
            if (description_counter > 556) {
                $('.description_5_counter').css('color', 'red');
            } else {
                $('.description_5_counter').css('color', 'black');
            }
        });

        description_5_editor.on('blur', function(e, src) {
            var end_date = false;
            end_date_month_5 = $('#end_date_month_5').val();
            end_date_year_5 = $('#end_date_year_5').val();
            if (end_date_month_5 == 'Presente') { end_date = true; }
            else {
                if (end_date_year_5 != '') { end_date = true; }
            }
            
            if (
                $('#occupation_title_5').val() != '' &&
                $('#company_5').val() != '' &&
                $('#start_date_month_5').val() != null &&
                $('#start_date_year_5').val() != null &&
                $('#end_date_month_5').val() != null &&
                end_date &&
                description_5_editor.getValue() != ''
            ) {
                processPDF('experience_details');
            }
        });

        var type = $('#type').val();

        // Click Back
        $('.candidate-portal__cv-form').on('click', '.back', function(e) {
            e.preventDefault();

            var redirect = $(this).attr('redirect');

            overlay.classList.add("active");

            var pdf_id = $('#pdf_id').val();
            var param = {
                "site": "talento", "msg": "saveCVCandidate",
            };
            var fields = {};
            fields['pdf_id'] = $('#pdf_id').val();
            fields['candidate_id'] = $('#candidate_id').val();
            fields['language'] = $('#language').val();
            fields['status'] = 'Completed';
            param['fields'] = fields;
            
            var fd = new FormData();
            fd.append('param', JSON.stringify(param));

            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.status == 1) {
                        window.location.href = redirect;
                    } else {
                        overlay.classList.remove("active");
                        M.toast({ html: response.msg });
                    }                    
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    overlay.classList.remove("active");
                }
            });

            return false;
        });

        // Type Edit Resume - Generate initial PDF preview
        // Use setTimeout to ensure Simditor editor is fully initialized
        if (type == 'edit') {
            setTimeout(function() {
                try {
                    processPDF();
                } catch (e) {
                    if (typeof ErrorHandler !== 'undefined' && typeof ErrorHandler.reportException === 'function') {
                        ErrorHandler.reportException(e, { context: 'cv_creator_premium_initial_pdf' });
                    }
                    console.error('CV Creator: Error in initial processPDF', e);
                    $(".pdf-loader").html('<div class="error-message" style="padding: 20px; text-align: center; color: #666;"><p>Error al cargar el PDF. Por favor, recarga la página.</p></div>');
                }
            }, 500);
        }

        /** DOWNLOAD PDF TRIGGER **/
        $('.download_pdf a').on('click', function() {
            var pdf_id = $('#pdf_id').val();
            var update_profile = $(this).attr('update_profile');


            $.psEmit('CV Creator CSAT Login', { onceKey: 'cv_login_' + pdf_id })
            .done(function () {
              console.info('[PageSense] emitido: CV Creator CSAT Login');
            })
            .fail(function () {
              console.warn('[PageSense] NO emitido (timeout o no listo)');
            });

            overlay.classList.add("active");
            $('#modal-cv-creator-download').modal('close');

            var status = $('#status').val();
            if (status != 'Completed') { status = 'Downloaded'; }
            var param = {
                "site": "talento", "msg": "saveCVCandidate",
            };
            var fields = {};
            fields['pdf_id'] = $('#pdf_id').val();
            fields['candidate_id'] = $('#candidate_id').val();
            fields['language'] = $('#language').val();
            fields['status'] = status;
            fields['update_profile'] = update_profile;
            param['fields'] = fields;

            var fd = new FormData();
            fd.append('param', JSON.stringify(param));

            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.status == 1) {
                        // Si update_profile es "1", mostrar mensaje de éxito
                        if (update_profile == '1') {
                            M.toast({ html: 'Tu perfil ha sido actualizado exitosamente.' });
                        }

                        // Descargar el PDF después de guardar exitosamente
                        const pdfUrl = template_directory + '/cvs/' + pdf_id + '.pdf';

                        $('<a>', {
                            href: pdfUrl,
                            target: '_blank',
                            download: pdf_id + '.pdf',
                        }).appendTo('body')[0].click();

                        overlay.classList.remove("active");
                    } else {
                        overlay.classList.remove("active");
                        M.toast({ html: response.msg || 'Error al guardar el CV. Por favor, intenta de nuevo.' });
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    overlay.classList.remove("active");
                    M.toast({ html: 'Error de conexión. Por favor, intenta de nuevo.' });
                }
            });
        });

        /** UPLOAD IMAGE TRIGGER**/
        $('.professional-info .cta a').on('click', function() {
            $('#avatar').trigger('click');
            return false;
        });

        /** UPLOAD IMAGE TRIGGER**/
        $('.professional-info .cta input').on('change', function() {
            // URL Photo Init
            var url_photo = '';

            //Check File Type
            var file_type = ''
            var file_size = 5.0
            if (this.files[0]) {
                file_type = this.files[0].type;
                file_size = this.files[0].size;
                file_size = parseFloat(file_size / (1024 ** 2));    
            }

            //Check if File is less than 2MB
            if (file_size <= 5.0)
            {
                $('.professional-info .cta a').addClass('disabled');
                $('.professional-info .cta a').text('Subiendo...');
                $('.professional-info .cta a').attr('data-url','javascript:void(0);');

                var pdf_id = $('#pdf_id').val();

                var param = {
                    "site": "talento",
                    "msg": "saveResumeAvatar",
                    "fields": {
                        "avatar_file_type": file_type,
                        "resume_id": pdf_id
                    }
                };

                var fd = new FormData();
                fd.append('file', this.files[0]);
                fd.append('param', JSON.stringify(param));

                $.ajax({
                    url: base_url + '/api',
                    data: fd,
                    processData: false,
                    contentType: false,
                    type: 'POST',
                    success: function (data) {
                        //Check Result
                        if (data.status == 1) {
                            //Change Image
                            $('.professional-info .avatar img').attr('src', data.base64);
                            $('.professional-info .cta a').removeClass('disabled');
                            $('.professional-info .cta a').text('Subir Fotografía');
                            $('.professional-info form #url_photo').val(data.data);
                            $('.professional-info form #url_photo64').val(data.base64);
                            processPDF('url_photo');
                        } else {
                            //Show Error
                            M.toast({ html: data.data });
                            $('.professional-info .cta a').removeClass('disabled');
                            $('.professional-info .cta a').text('Subir Fotografía');
                        }
                    }
                });
            }
            else
            {
                M.toast({ html: "El límite de tamaño del comprobante es de 2MB. Selecciona otro archivo." });
            }
        });

        /** ADD NEW LANGUAGE */
        $('.languages_cta a').on('click', function(e) {
            e.preventDefault();

            var count = $('#other_languages').val();
            count = parseInt(count) + 1;

            //Clear Language Fields
            $('#other_languages_id_' + count).val('');
            $('#language_name_' + count).val('');
            $('#language_level_' + count).val('');

            //Add Language
            $('#language_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#other_languages').val(count.toString());

            //Hide Add Language Button
            if (count == 5) {
                $('.languages_cta').fadeOut(0);
            }

            if (count == 2) {
                $('.delete_language').fadeIn('slow');
            }

            return false;
        });

        /** DELETE LANGUAGE */
        $('.delete_language a').on('click', function(e) {
            e.preventDefault();

            var count = $('#other_languages').val();
            
            //Remove Language
            $('#language_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#other_languages_id_' + count).val('');
            $('#language_name_' + count).val('');
            $('#language_level_' + count).val('');
            
            //Decrement Language Count
            $('#other_languages').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count == 5) {
                $('.languages_cta').fadeIn('slow');
            }

            if (count == 2) {
                $('.delete_language').fadeOut(0);
            }

            processPDF('other_languages');

            return false;
        });

        /** REINITIALIZE SIMDITOR EDITOR */
        function reinitializeDescriptionEditor(count) {
            var editorId = '#description_' + count;
            var counterClass = '.description_' + count + '_counter';
            var editorVar;

            // Destroy existing editor instance if it exists
            if (count == 2 && description_2_editor) {
                description_2_editor.destroy();
            } else if (count == 3 && description_3_editor) {
                description_3_editor.destroy();
            } else if (count == 4 && description_4_editor) {
                description_4_editor.destroy();
            } else if (count == 5 && description_5_editor) {
                description_5_editor.destroy();
            }

            // Create new editor instance
            editorVar = new Simditor({
                textarea: $(editorId),
                placeholder: '',
                upload: false,
                cleanPaste: true,
                pasteImage: false,
                toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', '|', 'ol', 'ul', '|', 'link'],
            });

            // Attach valuechanged event
            editorVar.on('valuechanged', function(e, src) {
                var description = editorVar.getValue();
                var description_counter = description.length;
                $(counterClass).text(description_counter + '/556');
                if (description_counter > 556) {
                    $(counterClass).css('color', 'red');
                } else {
                    $(counterClass).css('color', 'black');
                }
            });

            // Attach blur event based on count
            editorVar.on('blur', function(e, src) {
                var end_date = false;
                var end_date_month = $('#end_date_month_' + count).val();
                var end_date_year = $('#end_date_year_' + count).val();
                if (end_date_month == 'Presente') { end_date = true; }
                else {
                    if (end_date_year != '') { end_date = true; }
                }

                if (
                    $('#occupation_title_' + count).val() != '' &&
                    $('#company_' + count).val() != '' &&
                    $('#start_date_month_' + count).val() != null &&
                    $('#start_date_year_' + count).val() != null &&
                    $('#end_date_month_' + count).val() != null &&
                    end_date &&
                    editorVar.getValue() != ''
                ) {
                    processPDF('experience_details');
                }
            });

            // Update the global editor variable
            if (count == 2) {
                description_2_editor = editorVar;
            } else if (count == 3) {
                description_3_editor = editorVar;
            } else if (count == 4) {
                description_4_editor = editorVar;
            } else if (count == 5) {
                description_5_editor = editorVar;
            }
        }

        /** ADD NEW EXPERIENCE */
        $('.professional-experience_cta a').on('click', function(e) {
            var count = $('#experience_details').val();
            count = parseInt(count) + 1;

            //Clear Language Fields
            $('#experience_details_id_' + count).val('');
            $('#occupation_title_' + count).val('');
            $('#company_' + count).val('');
            $('#start_date_month_' + count).val('');
            $('#start_date_year_' + count).val('');
            $('#end_date_month_' + count).val('');
            $('#end_date_year_' + count).val('');
            if (count == 2) { description_2_editor.setValue(''); }
            if (count == 3) { description_3_editor.setValue(''); }
            if (count == 4) { description_4_editor.setValue(''); }
            if (count == 5) { description_5_editor.setValue(''); }

            //Add Language
            $('#professional-experience_block_' + count.toString()).fadeIn('slow', function() {
                // Reinitialize Simditor editor after block is visible
                if (count >= 2 && count <= 5) {
                    reinitializeDescriptionEditor(count);
                }
            });

            //Increment Language Count
            $('#experience_details').val(count.toString());

            //Hide Add Language Button
            if (count == 5) {
                $('.professional-experience_cta').fadeOut(0);
            }

            //Hide Delete Experience Button
            if (count == 2) {
                $('.delete_experience').fadeIn('slow');
            }

            return false;
        });

        /** DELETE EXPERIENCE */
        $('.delete_experience a').on('click', function(e) {
            e.preventDefault();

            var count = $('#experience_details').val();
            
            //Remove Language
            $('#professional-experience_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#experience_details_id_' + count).val('');
            $('#occupation_title_' + count).val('');
            $('#company_' + count).val('');
            $('#start_date_month_' + count).val('');
            $('#start_date_year_' + count).val('');
            $('#end_date_month_' + count).val('');
            $('#end_date_year_' + count).val('');
            if (count == 2) { description_2_editor.setValue(''); }
            if (count == 3) { description_3_editor.setValue(''); }
            if (count == 4) { description_4_editor.setValue(''); }
            if (count == 5) { description_5_editor.setValue(''); }

            //Decrement Language Count
            $('#experience_details').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count == '5') {
                $('.professional-experience_cta').fadeIn('slow');
            }

            //Hide Delete Experience Button
            if (count == '2') {
                $('.delete_experience').fadeOut(0);
            }

            processPDF('experience_details');

            return false;
        });

        /** ADD NEW SKILL */
        $('.skills_cta a').on('click', function(e) {
            e.preventDefault();

            var count = $('#skills').val();
            count = parseInt(count) + 1;

            //Clear Language Fields
            $('#other_skill_' + count).val('');
            $('#n_' + count + '_year_of_experience' + count).val('');

            //Add Language
            $('.skills_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#skills').val(count.toString());

            //Hide Add Language Button
            if (count == 10) {
                $('.skills_cta').fadeOut(0);
            }

            if (count > 3) {
                $('.delete_skill').fadeIn('slow');
            }

            return false;
        });

        /** DELETE SKILL */
        $('.delete_skill a').on('click', function(e) {
            e.preventDefault();

            var count = $('#skills').val();
            
            //Remove Language
            $('.skills_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#other_skill_' + count).val('');
            $('#n_' + count + '_year_of_experience' + count).val('');
            
            //Decrement Language Count
            $('#skills').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 3) {
                $('.skills_cta').fadeIn('slow');
            }

            if (count == 4) {
                $('.delete_skill').fadeOut(0);
            }

            processPDF('skills');

            return false;
        });

        /** ADD EDUCATION */
        $('.education_cta a').on('click', function(e) {
            var count = $('#educational_details').val();
            count = parseInt(count) + 1;
            
            //Clear Language Fields
            $('#major_department_' + count).val('');
            $('#currently_pursuing_' + count).val('');
            $('#education_details_id_' + count).val('');
            $('#degree_'+ count).val('');
            $('#institute_school_' + count).val('');
            $('#education_start_date_month_' + count).val('');
            $('#education_start_date_year_' + count).val('');
            $('#education_end_date_month_' + count).val('');
            $('#education_end_date_year_' + count).val('');

            //Add Language
            $('.education_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#educational_details').val(count.toString());

            //Hide Add Language Button
            if (count == 3) {
                $('.education_cta').fadeOut(0);
            }

            //Hide Delete Experience Button
            if (count > 1) {
                $('.delete_education').fadeIn('slow');
            }

            return false;
        });

        /** DELETE EDUCATION */
        $('.delete_education a').on('click', function(e) {
            e.preventDefault();

            var count = $('#educational_details').val();
            
            //Remove Language
            $('.education_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#major_department_' + count).val('');
            $('#currently_pursuing_' + count).val('');
            $('#education_details_id_' + count).val('');
            $('#degree_'+ count).val('');
            $('#institute_school_' + count).val('');
            $('#education_start_date_month_' + count).val('');
            $('#education_start_date_year_' + count).val('');
            $('#education_end_date_month_' + count).val('');
            $('#education_end_date_year_' + count).val('');

            //Decrement Language Count
            $('#educational_details').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 1) {
                $('.education_cta').fadeIn('slow');
            }

            //Hide Delete Experience Button
            if (count == 2) {
                $('.delete_education').fadeOut(0);
            }

            processPDF('educational_details');

            return false;
        });

        /** ADD NEW LINK */
        $('.links_cta a').on('click', function(e) {
            e.preventDefault();

            var count = $('#portfolio_links').val();
            count = parseInt(count) + 1;

            //Clear Language Fields
            $('#portfolio_links_id_' + count).val('');
            $('#platform_' + count).val('');
            $('#url_' + count).val('');

            //Add Language
            $('.links_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#portfolio_links').val(count.toString());

            //Hide Add Language Button
            if (count == 10) {
                $('.links_cta').fadeOut(0);
            }

            if (count > 1) {
                $('.delete_link').fadeIn('slow');
            }

            return false;
        });

        /** DELETE LINK */
        $('.delete_link a').on('click', function(e) {
            e.preventDefault();

            var count = $('#portfolio_links').val();
            
            //Remove Language
            $('.links_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#portfolio_links_id_' + count).val('');
            $('#platform_' + count).val('');
            $('#url_' + count).val('');
            
            //Decrement Language Count
            $('#portfolio_links').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 1) {
                $('.links_cta').fadeIn('slow');
            }

            if (count == 2) {
                $('.delete_link').fadeOut(0);
            }

            processPDF('portfolio_links');

            return false;
        });

        /** ADD EDUCATION */
        $('.certifications_cta a').on('click', function(e) {
            var count = $('#certifications').val();
            count = parseInt(count) + 1;
            
            //Clear Language Fields
            $('#certification_id_' + count).val('');
            $('#certification_course_name_' + count).val('');
            $('#certification_institute_school_' + count).val('');
            $('#certification_start_month_' + count).val('');
            $('#certification_start_year_' + count).val('');
            $('#certification_end_month_' + count).val('');
            $('#certification_end_year_' + count).val('');

            //Add Language
            $('.certification_block_' + count.toString()).fadeIn('slow');

            //Increment Language Count
            $('#certifications').val(count.toString());

            //Hide Add Language Button
            if (count == 3) {
                $('.certifications_cta').fadeOut(0);
            }

            //Hide Delete Experience Button
            if (count > 1) {
                $('.delete_certification').fadeIn('slow');
            }

            return false;
        });

        /** DELETE EDUCATION */
        $('.delete_certification a').on('click', function(e) {
            e.preventDefault();

            var count = $('#certifications').val();
            
            //Remove Language
            $('.certification_block_' + count).fadeOut(0);

            //Clear Language Fields
            $('#certification_id_' + count).val('');
            $('#certification_course_name_' + count).val('');
            $('#certification_institute_school_' + count).val('');
            $('#certification_start_month_' + count).val('');
            $('#certification_start_year_' + count).val('');
            $('#certification_end_month_' + count).val('');
            $('#certification_end_year_' + count).val('');

            //Decrement Language Count
            $('#certifications').val(parseInt(count) - 1);

            //Hide Add Language Button
            if (count > 1) {
                $('.certifications_cta').fadeIn('slow');
            }

            //Hide Delete Experience Button
            if (count == 2) {
                $('.delete_certification').fadeOut(0);
            }

            processPDF('certifications');

            return false;
        });

        // Input Change
        $(document).on('change', 'form input[type=text]', function(e) {
            var mw_field = $(this).attr('mw_field');
            if (mw_field == undefined || mw_field == null) { mw_field = ''; }
            var urlMatch = /^url_(\d+)$/.exec(mw_field);
            if (urlMatch) {
                var $portfolioUrlField = $('#' + mw_field);
                if ($portfolioUrlField.length) {
                    $portfolioUrlField.val(cvcreatorNormalizeUrlValue($portfolioUrlField.val()));
                    cvcreatorSyncPortfolioUrlFieldFromInput($portfolioUrlField);
                    var rawUrl = String($portfolioUrlField.val() || '').trim();
                    if (cvcreatorIsValidPortfolioUrl(rawUrl) && $('#platform_' + urlMatch[1]).val() != '' && rawUrl !== '') {
                        processPDF('portfolio_links');
                    }
                }
                return;
            }

            switch (mw_field) {
                // Experience Details
                case 'occupation_title_1':
                case 'company_1':
                    var end_date = false;
                    end_date_month_1 = $('#end_date_month_1').val();
                    end_date_year_1 = $('#end_date_year_1').val();
                    if (end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_1 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_1').val() != '' &&
                        $('#company_1').val() != '' &&
                        $('#start_date_month_1').val() != null &&
                        $('#start_date_year_1').val() != null &&
                        $('#end_date_month_1').val() != null &&
                        end_date &&
                        description_1_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_2':
                case 'company_2':
                    var end_date = false;
                    end_date_month_2 = $('#end_date_month_2').val();
                    end_date_year_2 = $('#end_date_year_2').val();
                    if (end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_2 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_2').val() != '' &&
                        $('#company_2').val() != '' &&
                        $('#start_date_month_2').val() != null &&
                        $('#start_date_year_2').val() != null &&
                        $('#end_date_month_2').val() != null &&
                        end_date &&
                        description_2_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_3':
                case 'company_3':
                    var end_date = false;
                    end_date_month_3 = $('#end_date_month_3').val();
                    end_date_year_3 = $('#end_date_year_3').val();
                    if (end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_3 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_3').val() != '' &&
                        $('#company_3').val() != '' &&
                        $('#start_date_month_3').val() != null &&
                        $('#start_date_year_3').val() != null &&
                        $('#end_date_month_3').val() != null &&
                        end_date &&
                        description_3_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_4':
                case 'company_4':
                    var end_date = false;
                    end_date_month_4 = $('#end_date_month_4').val();
                    end_date_year_4 = $('#end_date_year_4').val();
                    if (end_date_month_4 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_4 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_4').val() != '' &&
                        $('#company_4').val() != '' &&
                        $('#start_date_month_4').val() != null &&
                        $('#start_date_year_4').val() != null &&
                        $('#end_date_month_4').val() != null &&
                        end_date &&
                        description_4_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'occupation_title_5':
                case 'company_5':
                    var end_date = false;
                    end_date_month_5 = $('#end_date_month_5').val();
                    end_date_year_5 = $('#end_date_year_5').val();
                    if (end_date_month_5 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_5 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_5').val() != '' &&
                        $('#company_5').val() != '' &&
                        $('#start_date_month_5').val() != null &&
                        $('#start_date_year_5').val() != null &&
                        $('#end_date_month_5').val() != null &&
                        end_date &&
                        description_5_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                // Education Details
                case 'major_department_1':
                case 'institute_school_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#education_end_date_month_1').val();
                    education_end_date_year_1 = $('#education_end_date_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != '') { end_date = true; }
                    }

                    if (
                        $('#major_department_1').val() != '' &&
                        $('#institute_school_1').val() != '' &&
                        $('#education_start_date_month_1').val() != null &&
                        $('#education_start_date_year_1').val() != null &&
                        $('#education_end_date_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'major_department_2':
                case 'institute_school_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#education_end_date_month_2').val();
                    education_end_date_year_2 = $('#education_end_date_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != '') { end_date = true; }
                    }

                    if (
                        $('#major_department_2').val() != '' &&
                        $('#institute_school_2').val() != '' &&
                        $('#education_start_date_month_2').val() != null &&
                        $('#education_start_date_year_2').val() != null &&
                        $('#education_end_date_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'major_department_3':
                case 'institute_school_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#education_end_date_month_3').val();
                    education_end_date_year_3 = $('#education_end_date_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != '') { end_date = true; }
                    }

                    if (
                        $('#major_department_3').val() != '' &&
                        $('#institute_school_3').val() != '' &&
                        $('#education_start_date_month_3').val() != null &&
                        $('#education_start_date_year_3').val() != null &&
                        $('#education_end_date_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                // Certifications
                case 'certification_course_name_1':
                case 'certification_institute_school_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#certification_end_month_1').val();
                    education_end_date_year_1 = $('#certification_end_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_1').val() != '' &&
                        $('#certification_institute_school_1').val() != '' &&
                        $('#certification_start_month_1').val() != null &&
                        $('#certification_start_year_1').val() != null &&
                        $('#certification_end_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_course_name_2':
                case 'certification_institute_school_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#certification_end_month_2').val();
                    education_end_date_year_2 = $('#certification_end_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_2').val() != '' &&
                        $('#certification_institute_school_2').val() != '' &&
                        $('#certification_start_month_2').val() != null &&
                        $('#certification_start_year_2').val() != null &&
                        $('#certification_end_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_course_name_3':
                case 'certification_institute_school_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#certification_end_month_3').val();
                    education_end_date_year_3 = $('#certification_end_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_3').val() != '' &&
                        $('#certification_institute_school_3').val() != '' &&
                        $('#certification_start_month_3').val() != null &&
                        $('#certification_start_year_3').val() != null &&
                        $('#certification_end_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                default:
                    processPDF(mw_field);
                    break;
            }
        });

        // Input Tel Change
        $(document).on('change', 'form input[type=tel]', function(e) {
            var mw_field = $(this).attr('mw_field');
            if (mw_field == undefined || mw_field == null) { mw_field = ''; }
            processPDF(mw_field);            
        });

        // Select Change
        $(document).on('change', 'form select', function(e) {
            var mw_field = $(this).attr('mw_field');
            if (mw_field == undefined || mw_field == null) { mw_field = ''; }
            
            switch (mw_field) {
                // Other Languages
                case 'language_name_1':
                case 'language_level_1':
                    if ($('#language_name_1').val() != null && $('#language_level_1').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_2':
                case 'language_level_2':
                    if ($('#language_name_2').val() != null && $('#language_level_2').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_3':
                case 'language_level_3':
                    if ($('#language_name_3').val() != null && $('#language_level_3').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_4':
                case 'language_level_4':
                    if ($('#language_name_4').val() != null && $('#language_level_4').val() != null) { processPDF('other_languages'); }
                    break;
                case 'language_name_5':
                case 'language_level_5':
                    if ($('#language_name_5').val() != null && $('#language_level_5').val() != null) { processPDF('other_languages'); }
                    break;
                // Experience Details
                case 'start_date_month_1':
                case 'start_date_year_1':
                case 'end_date_month_1':
                case 'end_date_year_1':
                    var end_date = false;
                    end_date_month_1 = $('#end_date_month_1').val();
                    end_date_year_1 = $('#end_date_year_1').val();
                    if (end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_1 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_1').val() != '' &&
                        $('#company_1').val() != '' &&
                        $('#start_date_month_1').val() != null &&
                        $('#start_date_year_1').val() != null &&
                        $('#end_date_month_1').val() != null &&
                        end_date &&
                        description_1_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_2':
                case 'start_date_year_2':
                case 'end_date_month_2':
                case 'end_date_year_2':
                    var end_date = false;
                    end_date_month_2 = $('#end_date_month_2').val();
                    end_date_year_2 = $('#end_date_year_2').val();
                    if (end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_2 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_2').val() != '' &&
                        $('#company_2').val() != '' &&
                        $('#start_date_month_2').val() != '' &&
                        $('#start_date_year_2').val() != '' &&
                        $('#end_date_month_2').val() != '' &&
                        end_date &&
                        description_2_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_3':
                case 'start_date_year_3':
                case 'end_date_month_3':
                case 'end_date_year_3':
                    var end_date = false;
                    end_date_month_3 = $('#end_date_month_3').val();
                    end_date_year_3 = $('#end_date_year_3').val();
                    if (end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_3 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_3').val() != '' &&
                        $('#company_3').val() != '' &&
                        $('#start_date_month_3').val() != null &&
                        $('#start_date_year_3').val() != null &&
                        $('#end_date_month_3').val() != null &&
                        end_date &&
                        description_3_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_4':
                case 'start_date_year_4':
                case 'end_date_month_4':
                case 'end_date_year_4':
                    var end_date = false;
                    end_date_month_4 = $('#end_date_month_4').val();
                    end_date_year_4 = $('#end_date_year_4').val();
                    if (end_date_month_4 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_4 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_4').val() != '' &&
                        $('#company_4').val() != '' &&
                        $('#start_date_month_4').val() != null &&
                        $('#start_date_year_4').val() != null &&
                        $('#end_date_month_4').val() != null &&
                        end_date &&
                        description_4_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                case 'start_date_month_5':
                case 'start_date_year_5':
                case 'end_date_month_5':
                case 'end_date_year_5':
                    var end_date = false;
                    end_date_month_5 = $('#end_date_month_5').val();
                    end_date_year_5 = $('#end_date_year_5').val();
                    if (end_date_month_5 == 'Presente') { end_date = true; }
                    else {
                        if (end_date_year_5 != '') { end_date = true; }
                    }

                    if (
                        $('#occupation_title_5').val() != '' &&
                        $('#company_5').val() != '' &&
                        $('#start_date_month_5').val() != null &&
                        $('#start_date_year_5').val() != null &&
                        $('#end_date_month_5').val() != null &&
                        end_date &&
                        description_5_editor.getValue() != ''
                    ) {
                        processPDF('experience_details');
                    }
                    break;
                // Skills
                case 'primary_skill':
                case 'n_1_year_of_experience':
                    if ($('#primary_skill').val() != null && $('#n_1_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'secondary_skill':
                case 'n_2_year_of_experience':
                    if ($('#secondary_skill').val() != null && $('#n_2_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'third_skill':
                case 'n_3_year_of_experience':
                    if ($('#third_skill').val() != null && $('#n_3_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_4':
                case 'n_4_year_of_experience':
                    if ($('#other_skill_4').val() != null && $('#n_4_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_5':
                case 'n_5_year_of_experience':
                    if ($('#other_skill_5').val() != null && $('#n_5_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_6':
                case 'n_6_year_of_experience':
                    if ($('#other_skill_6').val() != null && $('#n_6_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_7':
                case 'n_7_year_of_experience':
                    if ($('#other_skill_7').val() != null && $('#n_7_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_8':
                case 'n_8_year_of_experience':
                    if ($('#other_skill_8').val() != null && $('#n_8_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_9':
                case 'n_9_year_of_experience':
                    if ($('#other_skill_9').val() != null && $('#n_9_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                case 'other_skill_10':
                case 'n_10_year_of_experience':
                    if ($('#other_skill_10').val() != null && $('#n_10_year_of_experience').val() != null) { processPDF('skills'); }
                    break;
                // Portfolio Links
                case 'platform_1': {
                    var raw_p1 = $('#url_1').val();
                    if (raw_p1.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p1)) {
                        cvcreatorSetPortfolioUrlErrorState(1, true);
                        break;
                    }
                    if ($('#platform_1').val() != null && raw_p1.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_2': {
                    var raw_p2 = $('#url_2').val();
                    if (raw_p2.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p2)) {
                        cvcreatorSetPortfolioUrlErrorState(2, true);
                        break;
                    }
                    if ($('#platform_2').val() != null && raw_p2.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_3': {
                    var raw_p3 = $('#url_3').val();
                    if (raw_p3.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p3)) {
                        cvcreatorSetPortfolioUrlErrorState(3, true);
                        break;
                    }
                    if ($('#platform_3').val() != null && raw_p3.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_4': {
                    var raw_p4 = $('#url_4').val();
                    if (raw_p4.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p4)) {
                        cvcreatorSetPortfolioUrlErrorState(4, true);
                        break;
                    }
                    if ($('#platform_4').val() != null && raw_p4.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_5': {
                    var raw_p5 = $('#url_5').val();
                    if (raw_p5.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p5)) {
                        cvcreatorSetPortfolioUrlErrorState(5, true);
                        break;
                    }
                    if ($('#platform_5').val() != null && raw_p5.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_6': {
                    var raw_p6 = $('#url_6').val();
                    if (raw_p6.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p6)) {
                        cvcreatorSetPortfolioUrlErrorState(6, true);
                        break;
                    }
                    if ($('#platform_6').val() != null && raw_p6.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_7': {
                    var raw_p7 = $('#url_7').val();
                    if (raw_p7.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p7)) {
                        cvcreatorSetPortfolioUrlErrorState(7, true);
                        break;
                    }
                    if ($('#platform_7').val() != null && raw_p7.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_8': {
                    var raw_p8 = $('#url_8').val();
                    if (raw_p8.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p8)) {
                        cvcreatorSetPortfolioUrlErrorState(8, true);
                        break;
                    }
                    if ($('#platform_8').val() != null && raw_p8.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_9': {
                    var raw_p9 = $('#url_9').val();
                    if (raw_p9.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p9)) {
                        cvcreatorSetPortfolioUrlErrorState(9, true);
                        break;
                    }
                    if ($('#platform_9').val() != null && raw_p9.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                case 'platform_10': {
                    var raw_p10 = $('#url_10').val();
                    if (raw_p10.trim() !== '' && !cvcreatorIsValidPortfolioUrl(raw_p10)) {
                        cvcreatorSetPortfolioUrlErrorState(10, true);
                        break;
                    }
                    if ($('#platform_10').val() != null && raw_p10.trim() !== '') { processPDF('portfolio_links'); }
                    break;
                }
                // Education Details
                case 'education_start_date_month_1':
                case 'education_start_date_year_1':
                case 'education_end_date_month_1':
                case 'education_end_date_year_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#education_end_date_month_1').val();
                    education_end_date_year_1 = $('#education_end_date_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != null) { end_date = true; }
                    }

                    if (
                        $('#major_department_1').val() != '' &&
                        $('#institute_school_1').val() != '' &&
                        $('#education_start_date_month_1').val() != null &&
                        $('#education_start_date_year_1').val() != null &&
                        $('#education_end_date_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'education_start_date_month_2':
                case 'education_start_date_year_2':
                case 'education_end_date_month_2':
                case 'education_end_date_year_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#education_end_date_month_2').val();
                    education_end_date_year_2 = $('#education_end_date_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != null) { end_date = true; }
                    }

                    if (
                        $('#major_department_2').val() != '' &&
                        $('#institute_school_2').val() != '' &&
                        $('#education_start_date_month_2').val() != null &&
                        $('#education_start_date_year_2').val() != null &&
                        $('#education_end_date_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                case 'education_start_date_month_3':
                case 'education_start_date_year_3':
                case 'education_end_date_month_3':
                case 'education_end_date_year_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#education_end_date_month_3').val();
                    education_end_date_year_3 = $('#education_end_date_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != null) { end_date = true; }
                    }

                    if (
                        $('#major_department_3').val() != '' &&
                        $('#institute_school_3').val() != '' &&
                        $('#education_start_date_month_3').val() != null &&
                        $('#education_start_date_year_3').val() != null &&
                        $('#education_end_date_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('educational_details');
                    }
                    break;
                // Certifications
                case 'certification_start_month_1':
                case 'certification_start_year_1':
                case 'certification_end_month_1':
                case 'certification_end_year_1':
                    var end_date = false;
                    education_end_date_month_1 = $('#certification_end_month_1').val();
                    education_end_date_year_1 = $('#certification_end_year_1').val();
                    if (education_end_date_month_1 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_1 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_1').val() != '' &&
                        $('#certification_institute_school_1').val() != '' &&
                        $('#certification_start_month_1').val() != null &&
                        $('#certification_start_year_1').val() != null &&
                        $('#certification_end_month_1').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_start_month_2':
                case 'certification_start_year_2':
                case 'certification_end_month_2':
                case 'certification_end_year_2':
                    var end_date = false;
                    education_end_date_month_2 = $('#certification_end_month_2').val();
                    education_end_date_year_2 = $('#certification_end_year_2').val();
                    if (education_end_date_month_2 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_2 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_2').val() != '' &&
                        $('#certification_institute_school_2').val() != '' &&
                        $('#certification_start_month_2').val() != null &&
                        $('#certification_start_year_2').val() != null &&
                        $('#certification_end_month_2').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                case 'certification_start_month_3':
                case 'certification_start_year_3':
                case 'certification_end_month_3':
                case 'certification_end_year_3':
                    var end_date = false;
                    education_end_date_month_3 = $('#certification_end_month_3').val();
                    education_end_date_year_3 = $('#certification_end_year_3').val();
                    if (education_end_date_month_3 == 'Presente') { end_date = true; }
                    else {
                        if (education_end_date_year_3 != null) { end_date = true; }
                    }

                    if (
                        $('#certification_course_name_3').val() != '' &&
                        $('#certification_institute_school_3').val() != '' &&
                        $('#certification_start_month_3').val() != null &&
                        $('#certification_start_year_3').val() != null &&
                        $('#certification_end_month_3').val() != null &&
                        end_date
                    ) {
                        processPDF('certifications');
                    }
                    break;
                default:
                    processPDF(mw_field);
                    break;
            }
        });

        function processPDF(mw_field) {
            var param = {
                "site": "talento", "msg": "processCVCandidate",
            };
            var fields = {};
            fields['language'] = $('#language').val();
            fields['type'] = $('#type').val();
            fields['pdf_id'] = $('#pdf_id').val();
            fields['candidate_id'] = $('#candidate_id').val();
            fields['original_type'] = $('#original_type').val();
            fields['first_name'] = $('#first_name').val();
            fields['last_name'] = $('#last_name').val();
            fields['second_last_name'] = $('#second_last_name').val();
            fields['email'] = $('#email').val();
            fields['mobile'] = $('#mobile').val();
            fields['url_photo'] = $('#url_photo').val();
            fields['url_photo64'] = $('#url_photo64').val();
            fields['current_job_title'] = $('#current_job_title').val();
            fields['years_of_experience'] = $('#years_of_experience').val();
            fields['country'] = $('#country').val();
            fields['state_province'] = $('#state').val();
            fields['city'] = $('#city').val();
            fields['email'] = $('#email').val();
            fields['mobile'] = $('#mobile').val();
            
            fields['professional_summary'] = resume_editor.getValue();
            
            fields['primary_skill'] = $('#primary_skill').val();
            fields['n_1_year_of_experience'] = $('#n_1_year_of_experience').val();
            fields['secondary_skill'] = $('#secondary_skill').val();
            fields['n_2_year_of_experience'] = $('#n_2_year_of_experience').val();
            fields['third_skill'] = $('#third_skill').val();
            fields['n_3_year_of_experience'] = $('#n_3_year_of_experience').val();
            fields['other_skill_4'] = $('#other_skill_4').val();
            fields['n_4_year_of_experience'] = $('#n_4_year_of_experience').val();
            fields['other_skill_5'] = $('#other_skill_5').val();
            fields['n_5_year_of_experience'] = $('#n_5_year_of_experience').val();
            fields['other_skill_6'] = $('#other_skill_6').val();
            fields['n_6_year_of_experience'] = $('#n_6_year_of_experience').val();
            fields['other_skill_7'] = $('#other_skill_7').val();
            fields['n_7_year_of_experience'] = $('#n_7_year_of_experience').val();
            fields['other_skill_8'] = $('#other_skill_8').val();
            fields['n_8_year_of_experience'] = $('#n_8_year_of_experience').val();
            fields['other_skill_9'] = $('#other_skill_9').val();
            fields['n_9_year_of_experience'] = $('#n_9_year_of_experience').val();
            fields['other_skill_10'] = $('#other_skill_10').val();
            fields['n_10_year_of_experience'] = $('#n_10_year_of_experience').val();

            // Other Languages with IDs
            fields['other_languages_id_1'] = ($('#other_languages_id_1').val()) ? $('#other_languages_id_1').val().trim() : '';
            fields['language_name_1'] = ($('#language_name_1').val()) ? $('#language_name_1').val() : '';
            fields['language_level_1'] = ($('#language_level_1').val()) ? $('#language_level_1').val() : '';
            fields['other_languages_id_2'] = ($('#other_languages_id_2').val()) ? $('#other_languages_id_2').val().trim() : '';
            fields['language_name_2'] = ($('#language_name_2').val()) ? $('#language_name_2').val() : '';
            fields['language_level_2'] = ($('#language_level_2').val()) ? $('#language_level_2').val() : '';
            fields['other_languages_id_3'] = ($('#other_languages_id_3').val()) ? $('#other_languages_id_3').val().trim() : '';
            fields['language_name_3'] = ($('#language_name_3').val()) ? $('#language_name_3').val() : '';
            fields['language_level_3'] = ($('#language_level_3').val()) ? $('#language_level_3').val() : '';
            fields['other_languages_id_4'] = ($('#other_languages_id_4').val()) ? $('#other_languages_id_4').val().trim() : '';
            fields['language_name_4'] = ($('#language_name_4').val()) ? $('#language_name_4').val() : '';
            fields['language_level_4'] = ($('#language_level_4').val()) ? $('#language_level_4').val() : '';
            fields['other_languages_id_5'] = ($('#other_languages_id_5').val()) ? $('#other_languages_id_5').val().trim() : '';
            fields['language_name_5'] = ($('#language_name_5').val()) ? $('#language_name_5').val() : '';
            fields['language_level_5'] = ($('#language_level_5').val()) ? $('#language_level_5').val() : '';

            fields['occupation_title_1'] = ($('#occupation_title_1').val()) ? $('#occupation_title_1').val().trim() : '';
            fields['company_1'] = ($('#company_1').val()) ? $('#company_1').val().trim() : '';
            fields['start_date_month_1'] = ($('#start_date_month_1').val()) ? $('#start_date_month_1').val().trim() : '';
            fields['start_date_year_1'] = ($('#start_date_year_1').val()) ? $('#start_date_year_1').val().trim() : '';
            fields['end_date_month_1'] = ($('#end_date_month_1').val()) ? $('#end_date_month_1').val().trim() : '';
            fields['end_date_year_1'] = ($('#end_date_year_1').val()) ? $('#end_date_year_1').val().trim() : '';
            fields['description_1'] = ($('#description_1').val()) ? $('#description_1').val().trim() : '';
            fields['occupation_title_2'] = ($('#occupation_title_2').val()) ? $('#occupation_title_2').val().trim() : '';
            fields['company_2'] = ($('#company_2').val()) ? $('#company_2').val().trim() : '';
            fields['start_date_month_2'] = ($('#start_date_month_2').val()) ? $('#start_date_month_2').val().trim() : '';
            fields['start_date_year_2'] = ($('#start_date_year_2').val()) ? $('#start_date_year_2').val().trim() : '';
            fields['end_date_month_2'] = ($('#end_date_month_2').val()) ? $('#end_date_month_2').val().trim() : '';
            fields['end_date_year_2'] = ($('#end_date_year_2').val()) ? $('#end_date_year_2').val().trim() : '';
            fields['description_2'] = ($('#description_2').val()) ? $('#description_2').val().trim() : '';
            fields['occupation_title_3'] = ($('#occupation_title_3').val()) ? $('#occupation_title_3').val().trim() : '';
            fields['company_3'] = ($('#company_3').val()) ? $('#company_3').val().trim() : '';
            fields['start_date_month_3'] = ($('#start_date_month_3').val()) ? $('#start_date_month_3').val().trim() : '';
            fields['start_date_year_3'] = ($('#start_date_year_3').val()) ? $('#start_date_year_3').val().trim() : '';
            fields['end_date_month_3'] = ($('#end_date_month_3').val()) ? $('#end_date_month_3').val().trim() : '';
            fields['end_date_year_3'] = ($('#end_date_year_3').val()) ? $('#end_date_year_3').val().trim() : '';
            fields['description_3'] = ($('#description_3').val()) ? $('#description_3').val().trim() : '';
            fields['occupation_title_4'] = ($('#occupation_title_4').val()) ? $('#occupation_title_4').val().trim() : '';
            fields['company_4'] = ($('#company_4').val()) ? $('#company_4').val().trim() : '';
            fields['start_date_month_4'] = ($('#start_date_month_4').val()) ? $('#start_date_month_4').val().trim() : '';
            fields['start_date_year_4'] = ($('#start_date_year_4').val()) ? $('#start_date_year_4').val().trim() : '';
            fields['end_date_month_4'] = ($('#end_date_month_4').val()) ? $('#end_date_month_4').val().trim() : '';
            fields['end_date_year_4'] = ($('#end_date_year_4').val()) ? $('#end_date_year_4').val().trim() : '';
            fields['description_4'] = ($('#description_4').val()) ? $('#description_4').val().trim() : '';
            fields['occupation_title_5'] = ($('#occupation_title_5').val()) ? $('#occupation_title_5').val().trim() : '';
            fields['company_5'] = ($('#company_5').val()) ? $('#company_5').val().trim() : '';
            fields['start_date_month_5'] = ($('#start_date_month_5').val()) ? $('#start_date_month_5').val().trim() : '';
            fields['start_date_year_5'] = ($('#start_date_year_5').val()) ? $('#start_date_year_5').val().trim() : '';
            fields['end_date_month_5'] = ($('#end_date_month_5').val()) ? $('#end_date_month_5').val().trim() : '';
            fields['end_date_year_5'] = ($('#end_date_year_5').val()) ? $('#end_date_year_5').val().trim() : '';
            fields['description_5'] = ($('#description_5').val()) ? $('#description_5').val().trim() : '';

            fields['major_department_1'] = ($('#major_department_1').val()) ? $('#major_department_1').val().trim() : '';
            fields['currently_pursuing_1'] = ($('#currently_pursuing_1').val()) ? $('#currently_pursuing_1').val().trim() : '';
            fields['education_details_id_1'] = ($('#education_details_id_1').val()) ? $('#education_details_id_1').val().trim() : '';
            fields['degree_1'] = ($('#degree_1').val()) ? $('#degree_1').val().trim() : '';
            fields['institute_school_1'] = ($('#institute_school_1').val()) ? $('#institute_school_1').val().trim() : '';
            fields['education_start_date_month_1'] = ($('#education_start_date_month_1').val()) ? $('#education_start_date_month_1').val().trim() : '';
            fields['education_start_date_year_1'] = ($('#education_start_date_year_1').val()) ? $('#education_start_date_year_1').val().trim() : '';
            fields['education_end_date_month_1'] = ($('#education_end_date_month_1').val()) ? $('#education_end_date_month_1').val().trim() : '';
            fields['education_end_date_year_1'] = ($('#education_end_date_year_1').val()) ? $('#education_end_date_year_1').val().trim() : '';
            fields['major_department_2'] = ($('#major_department_2').val()) ? $('#major_department_2').val().trim() : '';
            fields['currently_pursuing_2'] = ($('#currently_pursuing_2').val()) ? $('#currently_pursuing_2').val().trim() : '';
            fields['education_details_id_2'] = ($('#education_details_id_2').val()) ? $('#education_details_id_2').val().trim() : '';
            fields['degree_2'] = ($('#degree_2').val()) ? $('#degree_2').val().trim() : '';
            fields['institute_school_2'] = ($('#institute_school_2').val()) ? $('#institute_school_2').val().trim() : '';
            fields['education_start_date_month_2'] = ($('#education_start_date_month_2').val()) ? $('#education_start_date_month_2').val().trim() : '';
            fields['education_start_date_year_2'] = ($('#education_start_date_year_2').val()) ? $('#education_start_date_year_2').val().trim() : '';
            fields['education_end_date_month_2'] = ($('#education_end_date_month_2').val()) ? $('#education_end_date_month_2').val().trim() : '';
            fields['education_end_date_year_2'] = ($('#education_end_date_year_2').val()) ? $('#education_end_date_year_2').val().trim() : '';
            fields['major_department_3'] = ($('#major_department_3').val()) ? $('#major_department_3').val().trim() : '';
            fields['currently_pursuing_3'] = ($('#currently_pursuing_3').val()) ? $('#currently_pursuing_3').val().trim() : '';
            fields['education_details_id_3'] = ($('#education_details_id_3').val()) ? $('#education_details_id_3').val().trim() : '';
            fields['degree_3'] = ($('#degree_3').val()) ? $('#degree_3').val().trim() : '';
            fields['institute_school_3'] = ($('#institute_school_3').val()) ? $('#institute_school_3').val().trim() : '';
            fields['education_start_date_month_3'] = ($('#education_start_date_month_3').val()) ? $('#education_start_date_month_3').val().trim() : '';
            fields['education_start_date_year_3'] = ($('#education_start_date_year_3').val()) ? $('#education_start_date_year_3').val().trim() : '';
            fields['education_end_date_month_3'] = ($('#education_end_date_month_3').val()) ? $('#education_end_date_month_3').val().trim() : '';
            fields['education_end_date_year_3'] = ($('#education_end_date_year_3').val()) ? $('#education_end_date_year_3').val().trim() : '';

            cvcreatorApplyPortfolioFieldsForPdf(fields);

            fields['certification_id_1'] = ($('#certification_id_1').val()) ? $('#certification_id_1').val().trim() : '';
            fields['certification_course_name_1'] = ($('#certification_course_name_1').val()) ? $('#certification_course_name_1').val().trim() : '';
            fields['certification_institute_school_1'] = ($('#certification_institute_school_1').val()) ? $('#certification_institute_school_1').val().trim() : '';
            fields['certification_start_month_1'] = ($('#certification_start_month_1').val()) ? $('#certification_start_month_1').val().trim() : '';
            fields['certification_start_year_1'] = ($('#certification_start_year_1').val()) ? $('#certification_start_year_1').val().trim() : '';
            fields['certification_end_month_1'] = ($('#certification_end_month_1').val()) ? $('#certification_end_month_1').val().trim() : '';
            fields['certification_end_year_1'] = ($('#certification_end_year_1').val()) ? $('#certification_end_year_1').val().trim() : '';
            fields['certification_id_2'] = ($('#certification_id_2').val()) ? $('#certification_id_2').val().trim() : '';
            fields['certification_course_name_2'] = ($('#certification_course_name_2').val()) ? $('#certification_course_name_2').val().trim() : '';
            fields['certification_institute_school_2'] = ($('#certification_institute_school_2').val()) ? $('#certification_institute_school_2').val().trim() : '';
            fields['certification_start_month_2'] = ($('#certification_start_month_2').val()) ? $('#certification_start_month_2').val().trim() : '';
            fields['certification_start_year_2'] = ($('#certification_start_year_2').val()) ? $('#certification_start_year_2').val().trim() : '';
            fields['certification_end_month_2'] = ($('#certification_end_month_2').val()) ? $('#certification_end_month_2').val().trim() : '';
            fields['certification_end_year_2'] = ($('#certification_end_year_2').val()) ? $('#certification_end_year_2').val().trim() : '';
            fields['certification_id_3'] = ($('#certification_id_3').val()) ? $('#certification_id_3').val().trim() : '';
            fields['certification_course_name_3'] = ($('#certification_course_name_3').val()) ? $('#certification_course_name_3').val().trim() : '';
            fields['certification_institute_school_3'] = ($('#certification_institute_school_3').val()) ? $('#certification_institute_school_3').val().trim() : '';
            fields['certification_start_month_3'] = ($('#certification_start_month_3').val()) ? $('#certification_start_month_3').val().trim() : '';
            fields['certification_start_year_3'] = ($('#certification_start_year_3').val()) ? $('#certification_start_year_3').val().trim() : '';
            fields['certification_end_month_3'] = ($('#certification_end_month_3').val()) ? $('#certification_end_month_3').val().trim() : '';
            fields['certification_end_year_3'] = ($('#certification_end_year_3').val()) ? $('#certification_end_year_3').val().trim() : '';
            
            fields['mw_field'] = mw_field;
            param['fields'] = fields;
            
            $(".pdf-navbar .left").html('<i class="fas fa-cloud-upload-alt"></i> Procesando...');
            $(".pdf-loader").html('<div class="spinner"><div class="preloader-wrapper small active"><div class="spinner-layer spinner-blue-only"><div class="circle-clipper left"><div class="circle"></div></div><div class="gap-patch"><div class="circle"></div></div><div class="circle-clipper right"><div class="circle"></div></div></div></div></div>');

            
            var fd = new FormData();
            fd.append('param', JSON.stringify(param));
            
            var version = Date.now();
            
            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response && response.status == 1) {
                        $(".pdf-navbar .left").html('<i class="fas fa-cloud-upload-alt"></i> Guardado');
                        $(".pdf-loader").html('<div data-pdf="' + template_directory + '/cvs/' + $('#pdf_id').val() + '.pdf?version=' + version + '" data-options="no-print no-download" data-fit="fit" style="width: 100%; height: 100%;"></div>');
                        loadPDFMiniViewers(base_url, function () {
                            PDFMiniViewers.initialize(
                                base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf-worker.js',
                                base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/cmaps'
                            );
                            fixPDFPageNavigation();
                        });
                    } else {
                        console.error('CV Creator: Error generating PDF', response);
                        $(".pdf-navbar .left").html('<i class="fas fa-exclamation-triangle"></i> Error');
                        $(".pdf-loader").html('<div class="error-message" style="padding: 20px; text-align: center; color: #666;"><p>Error al generar el PDF. Por favor, intenta nuevamente.</p></div>');
                    }
                },
                error: function (xhr, status, error) {
                    if (typeof ErrorHandler !== 'undefined' && typeof ErrorHandler.reportException === 'function') {
                        ErrorHandler.reportException(error || status, {
                            context: 'cv_creator_premium_pdf_ajax',
                            status: xhr && xhr.status ? xhr.status : status
                        });
                    }
                    console.error('CV Creator: AJAX error generating PDF', status, error);
                    $(".pdf-navbar .left").html('<i class="fas fa-exclamation-triangle"></i> Error');
                    $(".pdf-loader").html('<div class="error-message" style="padding: 20px; text-align: center; color: #666;"><p>Error de conexión. Por favor, intenta nuevamente.</p></div>');
                }
            });
            
        }

        // Prompts CV Creator
        $('.candidate-portal__cv-form .service-prompt .prompts .prompt').on('click', function(e) {
            e.preventDefault();

            // Read Data
            var category = $(this).attr('category');
            var prompt = $(this).attr('prompt');
            var catalog = $(this).attr('catalog');
            var field = $(this).attr('field');
            var text = '';
            var current_job_title = $('#current_job_title').val();
            var years_of_experience = $('#years_of_experience').val();
            var primary_skill = $('#primary_skill').val();
            var n_1_year_of_experience = $('#n_1_year_of_experience').val();
            var secondary_skill = $('#secondary_skill').val();
            var n_2_year_of_experience = $('#n_2_year_of_experience').val();
            var third_skill = $('#third_skill').val();
            var n_3_year_of_experience = $('#n_3_year_of_experience').val();
            var resume_language = $('#language').val();

            switch (field) {
                case 'professional_summary':
                    text = resume_editor.getValue();
                    break;
                case 'description_1':
                    text = description_1_editor.getValue();
                    break;
                case 'description_2':
                    text = description_2_editor.getValue();
                    break;
                case 'description_3':
                    text = description_3_editor.getValue();
                    break;
                case 'description_4':
                    text = description_4_editor.getValue();
                    break;
                case 'description_5':
                    text = description_5_editor.getValue();
                    break;
                default:
                    text = resume_editor.getValue();
                    break;
            }

            if (current_job_title && years_of_experience && primary_skill && n_1_year_of_experience && secondary_skill && n_2_year_of_experience && third_skill && n_3_year_of_experience && resume_language) {

                var language = 'Spanish';
                if (resume_language == 'en') { language = 'English'; }

                if (category != 'Generar desde 0')
                {
                    if (!text) {
                        M.toast({ 
                            html: 'Para obtener mejores resultados, llena el Resumen Profesional',
                            classes: 'blue darken-1 rounded',
                            displayLength: 4000
                        });
                    }
                }

                prompt = prompt.replace('[current_role_title]', current_job_title);
                prompt = prompt.replace('[year_of_experience]', years_of_experience);
                prompt = prompt.replace('[skill1]', primary_skill);
                prompt = prompt.replace('[years_skill1]', n_1_year_of_experience);
                prompt = prompt.replace('[skill2]', secondary_skill);
                prompt = prompt.replace('[years_skill2]', n_2_year_of_experience);
                prompt = prompt.replace('[skill3]', third_skill);
                prompt = prompt.replace('[years_skill3]', n_3_year_of_experience);
                prompt = prompt.replace('[language]', language);
                prompt = prompt.replace('[Text]', text);

                var param = {
                    "site": "talento",
                    "msg": "promptCVCandidate",
                    "fields": {
                        "prompt": prompt,
                        "catalog": catalog,
                        "field": field
                    }
                };

                // Show Prompt Experience
                $('.candidate-portal__cv-form .prompt_experience .response .prompt').text(category);
                $('.candidate-portal__cv-form .prompt_experience .response .text').text('Procesando...');
                $('.candidate-portal__cv-form .prompt_experience .nav').html('<p>Procesando...</p>');
                $('.candidate-portal__cv-form .service-prompt .prompts').fadeOut(0);
                $('.candidate-portal__cv-form .prompt_experience').fadeIn('slow');
                
                var fd = new FormData();
                fd.append('param', JSON.stringify(param));
                
                //Request API
                $.ajax({
                    url: base_url + '/api',
                    type: 'POST',
                    data: fd,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        let text = response.data.choices[0].message.content;
                        
                        $('.candidate-portal__cv-form .prompt_experience .response .text').text(text);
                        $('.candidate-portal__cv-form .prompt_experience .nav').html(response.html);
                    } 
                });
            } else {

                var html_string = 'Para poder usar la función, debes completar los siguientes campos:<br/>';
                
                if (!current_job_title) { html_string += '<br/>- Rol Profesional'; }
                if (!years_of_experience) { html_string += '<br/>- Años de experiencia'; }
                if (!primary_skill) { html_string += '<br/>- Habilidad #1'; }
                if (!n_1_year_of_experience) { html_string += '<br/>- Años de experiencia en la Habilidad #1'; }
                if (!secondary_skill) { html_string += '<br/>- Habilidad #2'; }
                if (!n_2_year_of_experience) { html_string += '<br/>- Años de experiencia en la Habilidad #2'; }
                if (!third_skill) { html_string += '<br/>- Habilidad #3'; }
                if (!n_3_year_of_experience) { html_string += '<br/>- Años de experiencia en la Habilidad #3'; }
                
                M.toast({ 
                    html: html_string,
                    displayLength: 4000
                });
            }

            return false;
        });

        // Prompts CV Creator
        $(document).on('click', '.candidate-portal__cv-form .prompt_experience .nav li a', function(e) {
            e.preventDefault();

            // Read Data
            var category = $(this).attr('category');
            var prompt = $(this).attr('prompt');
            var catalog = $(this).attr('catalog');
            var field = $(this).attr('field');
            var text = '';
            var current_job_title = $('#current_job_title').val();
            var years_of_experience = $('#years_of_experience').val();
            var primary_skill = $('#primary_skill').val();
            var n_1_year_of_experience = $('#n_1_year_of_experience').val();
            var secondary_skill = $('#secondary_skill').val();
            var n_2_year_of_experience = $('#n_2_year_of_experience').val();
            var third_skill = $('#third_skill').val();
            var n_3_year_of_experience = $('#n_3_year_of_experience').val();
            var resume_language = $('#language').val();

            switch (field) {
                case 'professional_summary':
                    text = resume_editor.getValue();
                    break;
                case 'description_1':
                    text = description_1_editor.getValue();
                    break;
                case 'description_2':
                    text = description_2_editor.getValue();
                    break;
                case 'description_3':
                    text = description_3_editor.getValue();
                    break;
                case 'description_4':
                    text = description_4_editor.getValue();
                    break;
                case 'description_5':
                    text = description_5_editor.getValue();
                    break;
                default:
                    text = resume_editor.getValue();
                    break;
            }

            // Check Values
            if (current_job_title && years_of_experience && primary_skill && n_1_year_of_experience && secondary_skill && n_2_year_of_experience && third_skill && n_3_year_of_experience && resume_language) {

                // Read Values
                var language = 'Spanish';
                if (resume_language == 'en') { language = 'English'; }

                if (category != 'Generar desde 0')
                {
                    if (!text) {
                        M.toast({ 
                            html: 'Para obtener mejores resultados, llena el Resumen Profesional',
                            classes: 'blue darken-1 rounded',
                            displayLength: 4000
                        });
                    }
                }

                prompt = prompt.replace('[current_role_title]', current_job_title);
                prompt = prompt.replace('[year_of_experience]', years_of_experience);
                prompt = prompt.replace('[skill1]', primary_skill);
                prompt = prompt.replace('[years_skill1]', n_1_year_of_experience);
                prompt = prompt.replace('[skill2]', secondary_skill);
                prompt = prompt.replace('[years_skill2]', n_2_year_of_experience);
                prompt = prompt.replace('[skill3]', third_skill);
                prompt = prompt.replace('[years_skill3]', n_3_year_of_experience);
                prompt = prompt.replace('[language]', language);
                prompt = prompt.replace('[Text]', text);

                var param = {
                    "site": "talento",
                    "msg": "promptCVCandidate",
                    "fields": {
                        "prompt": prompt,
                        "catalog": catalog,
                        "field": field
                    }
                };

                // Show Prompt Experience
                $('.candidate-portal__cv-form .prompt_experience .response .prompt').text(category);
                $('.candidate-portal__cv-form .prompt_experience .response .text').text('Procesando...');
                $('.candidate-portal__cv-form .service-prompt .prompts').fadeOut(0);
                $('.candidate-portal__cv-form .prompt_experience').fadeIn('slow');
                
                var fd = new FormData();
                fd.append('param', JSON.stringify(param));
                
                //Request API
                $.ajax({
                    url: base_url + '/api',
                    type: 'POST',
                    data: fd,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        let text = response.data.choices[0].message.content;
                        
                        $('.candidate-portal__cv-form .prompt_experience .response .text').text(text);
                    } 
                });
            } else {

                var html_string = 'Para poder usar la función, debes completar los siguientes campos:<br/>';
                
                if (!current_job_title) { html_string += '<br/>- Rol Profesional'; }
                if (!years_of_experience) { html_string += '<br/>- Años de experiencia'; }
                if (!primary_skill) { html_string += '<br/>- Habilidad #1'; }
                if (!n_1_year_of_experience) { html_string += '<br/>- Años de experiencia en la Habilidad #1'; }
                if (!secondary_skill) { html_string += '<br/>- Habilidad #2'; }
                if (!n_2_year_of_experience) { html_string += '<br/>- Años de experiencia en la Habilidad #2'; }
                if (!third_skill) { html_string += '<br/>- Habilidad #3'; }
                if (!n_3_year_of_experience) { html_string += '<br/>- Años de experiencia en la Habilidad #3'; }
                
                M.toast({ 
                    html: html_string,
                    displayLength: 4000
                });
            }

            return false;
        });

        // Prompt Show List
        $('.candidate-portal__cv-form .service-prompt').on('click', function(e) {
            e.preventDefault();

            $('.candidate-portal__cv-form .service-prompt .prompts').toggle();

            return false;
        });

        // Prompt Hide Service Prompt
        $('.candidate-portal__cv-form .prompt_experience .right').on('click', function(e) {
            e.preventDefault();

            $('.candidate-portal__cv-form .prompt_experience').fadeOut(0);
            
            return false;
        });

        // Prompt Professional Summary
        $('.candidate-portal__cv-form .prompt_experience .response .actions .copy').on('click', function(e) {
            e.preventDefault();

            var text = $('.candidate-portal__cv-form .prompt_experience .response .text').text();
            navigator.clipboard.writeText(text);

            M.toast({
                html: 'Texto copiado al portapapeles',
                classes: 'blue darken-1 rounded',
                displayLength: 4000
            });

            return false;
        });

        // CV Translate
        $('.candidate-portal__cv-form .form .nav .translate').on('click', function(e) {
            e.preventDefault();

            $('.global-overlay-loader').fadeIn(100);
            var resume_id = $(this).attr('resume_id');
            
            //Process the Resume
            var param = {
                "site": "talento",
                "msg": "translateCVCandidate",
                "fields": {
                    "resume_id": resume_id
                }
            };
            
            //Build Payload API
            var fd = new FormData();
            fd.append('param', JSON.stringify(param));

            //Check File Exists
            $.ajax({
                url: base_url + '/api',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (response) {
                    //Check Result
                    if (response.status == 1) 
                    {
                        window.location.href = base_url + '/editar-cv/?type=edit&language=en&pdf_id=' + response.data.id + '&resumes=2';
                    }
                    else 
                    {
                        //Show Error
                        M.toast({ html: response.msg });
                        $('.global-overlay-loader').fadeOut(200);
                    }
                }
            });
            
            return false;
        });

        // Ver y Descargar Mobile
        $('.candidate-portal .candidate-portal__cv-form .full-height .switch_mobile .cta button').on('click', function(e) {
            e.preventDefault();

            var status_mobile = $('.candidate-portal .candidate-portal__cv-form .full-height .switch_mobile #status_mobile').val();
            if (status_mobile == '0') {
                $('#status_mobile').val('1');
                $('.candidate-portal .candidate-portal__cv-form .full-height .form').fadeOut(0);
                $('.candidate-portal .candidate-portal__cv-form .full-height .preview').fadeIn('slow');
                processPDF();
            } else {
                $('#status_mobile').val('0');
                $('.candidate-portal .candidate-portal__cv-form .full-height .preview').fadeOut(0);
                $('.candidate-portal .candidate-portal__cv-form .full-height .form').fadeIn('slow');
            }

            return false;
        });
    }

    // CV Creator
    if ($('.candidate-portal__cv-creator').length) {
        /*
        Paths can be relative or absolute but should be on the same server:
        path/to/pdf-worker.js ==> Tell PMV where pdf-worker.js is located
        path/to/cmaps         ==> Tell PMV where the CMAP folder is located.
        */
        loadPDFMiniViewers(base_url, function () {
            PDFMiniViewers.initialize(
                base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/pdf-worker.js',
                base_url + '/wp-content/themes/coderslink_cvcreator/assets/scripts/lib/pdf.js-mini-viewers-1.0.0/js/cmaps'
            );
            fixPDFPageNavigation();
            // Fix scale timing: pdf-viewer.js calcula el scale basado en viewer.offsetWidth
            // en el momento del render. Si el layout flex aún no expandió el contenedor,
            // el scale queda incorrecto (ej: 0.646). Al disparar 'resize' se recalcula
            // con el ancho real del contenedor ya expandido.
            var pdfScaleFixObserver = new MutationObserver(function (mutations, obs) {
                var page = document.querySelector('.pdf-viewer .page');
                if (page) {
                    obs.disconnect();
                    window.dispatchEvent(new Event('resize'));
                }
            });
            pdfScaleFixObserver.observe(document.body, { childList: true, subtree: true });
            // Fallback: si el MutationObserver no detecta la página en 3s, dispara igual
            setTimeout(function () {
                pdfScaleFixObserver.disconnect();
                window.dispatchEvent(new Event('resize'));
            }, 3000);
        });

        //Init Modal - CV Creator Source (for list page)
        $('#modal-cv-creator-source').modal({
            dismissible: false,
            preventScrolling: true,
            onOpenStart: function () {
                // Hide Step 1
                $('.candidate-portal__cv-creator .modal-cv-creator-source .step_1').fadeIn('slow');
                // Show Step 2
                $('.candidate-portal__cv-creator .modal-cv-creator-source .step_2').fadeOut(0);
            },
            onCloseEnd: function () {
                // Hide Step 1
                $('.candidate-portal__cv-creator .modal-cv-creator-source .step_1').fadeIn('slow');
                // Show Step 2
                $('.candidate-portal__cv-creator .modal-cv-creator-source .step_2').fadeOut(0);
            }
        });

        // Click Create CV
        $('.candidate-portal__cv-creator .cta button').on('click', function() {
            $('#modal-cv-creator-source').modal('open');
        });

        // Click New CV
        $('.candidate-portal__cv-creator .new').on('click', function() {
            var param = {
                "site": "talento",
                "msg": "initCVCandidate",
                "fields": {
                    "candidate_id": $('#candidate_id').val(),
                    "resume_type": "new",
                    "resume_language": "es"
                }
            };

            var fd = new FormData();
            fd.append('param', JSON.stringify(param));
            
            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    window.location.href = base_url + '/editar-cv/?type=edit&language=es&pdf_id=' + response.data.id;
                } 
            });
        });

        // Click Document CV
        $('.candidate-portal__cv-creator .document').on('click', function() {
            // Hide Step 1
            $('.candidate-portal__cv-creator .modal-cv-creator-source .step_1').fadeOut(0);
            // Show Step 2
            $('.candidate-portal__cv-creator .modal-cv-creator-source .step_2').fadeIn('slow');
        });

        // Click Profile CV
        $('.candidate-portal__cv-creator .profile').on('click', function() {
            var param = {
                "site": "talento",
                "msg": "initCVCandidate",
                "fields": {
                    "candidate_id": $('#candidate_id').val(),
                    "resume_type": "profile",
                    "resume_language": "es"
                }
            };

            var fd = new FormData();
            fd.append('param', JSON.stringify(param));
            
            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    window.location.href = base_url + '/editar-cv/?type=edit&language=es&pdf_id=' + response.data.id;
                } 
            });
        });

        // Click Resume Delete
        $('.candidate-portal__cv-creator .resume .delete').on('click', function() {
            var resume_id = $(this).attr('pdf_id');
            
            var param = {
                "site": "talento", "msg": "inactiveCVCandidate",
            };
            var fields = {};
            fields['resume_id'] = resume_id;
            param['fields'] = fields;

            var fd = new FormData();
            fd.append('param', JSON.stringify(param));

            //Request API
            $.ajax({
                url: base_url + '/api',
                type: 'POST',
                data: fd,
                processData: false,
                contentType: false,
                success: function (response) {
                    window.location.reload();
                } 
            });
        });

        //Upload Field
        $('.pond_cv_parser').filepond({
            instantUpload: false,
            labelIdle: 'Arrastra tu archivo aquí o haz clic para seleccionarlo. Máximo 15 pag (20MB)',
            acceptedFileTypes: ['application/pdf'],
            maxFileSize: '20MB',
            storeAsFile: true,
            onaddfile: function(error, file) {
                PutIntoInputParser();
            },
            onremovefile: function(error, file) {
                HideLoader();
            }
        });

        function HideLoader(){
            $('.candidate-portal__cv-creator .parser_info').fadeOut(0);
            $('.candidate-portal__cv-creator .parser_complete').fadeOut(0);
        }

        function PutIntoInputParser(){
            //Show Parser Info
            $('.candidate-portal__cv-creator .parser_info').fadeIn('slow');
            const filesFromPond = $('.pond_cv_parser').filepond('getFiles'); // pond is your instance
            const filesInput = $('#cv_ai')[0]; // element we created in step1
            const newFileList = new DataTransfer(); // new file list
            filesFromPond.forEach(file => { // Add each file to a list
                newFileList.items.add(file.file);
            });
            filesInput.files = newFileList.files; // Set the file list
            
            //Process the Resume
            var param = {
                "site": "talento",
                "msg": "initCVCandidate",
                "fields": {
                    "candidate_id": $('#candidate_id').val(),
                    "resume_type": "document",
                    "resume_language": "es"
                }
            };
            
            //Build Payload API
            var fd = new FormData();
            fd.append('file', $('#cv_ai')[0].files[0]);
            fd.append('param', JSON.stringify(param));

            //Check File Exists
            if ($('#cv_ai')[0].files[0]) {
                $.ajax({
                    url: base_url + '/api',
                    data: fd,
                    processData: false,
                    contentType: false,
                    type: 'POST',
                    success: function (response) {
                        //Check Result
                        if (response.status == 1) 
                        {
                            $('.candidate-portal__cv-creator .parser_info').fadeOut(0);
                            $('.candidate-portal__cv-creator .parser_complete').fadeIn('slow');
                            window.location.href = base_url + '/editar-cv/?type=edit&language=es&pdf_id=' + response.data.id;
                        }
                        else 
                        {
                            //Show Error
                            M.toast({ html: response.msg });
                        }
                    }
                });
            } else {
                M.toast({ html: "No hay ningún CV adjunto." });
            }
        }

        $('.candidate-portal__cv-creator .resume .translate').on('click', function(e) {
            e.preventDefault();

            $('.global-overlay-loader').fadeIn(100);
            var resume_id = $(this).attr('resume_id');
            
            //Process the Resume
            var param = {
                "site": "talento",
                "msg": "translateCVCandidate",
                "fields": {
                    "resume_id": resume_id
                }
            };
            
            //Build Payload API
            var fd = new FormData();
            fd.append('param', JSON.stringify(param));

            //Check File Exists
            $.ajax({
                url: base_url + '/api',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (response) {
                    //Check Result
                    if (response.status == 1) 
                    {
                        window.location.href = base_url + '/editar-cv/?type=edit&language=en&pdf_id=' + response.data.id + '&resumes=2';
                    }
                    else 
                    {
                        //Show Error
                        M.toast({ html: response.msg });
                        $('.global-overlay-loader').fadeOut(200);
                    }
                }
            });
            
            return false;
        });

        $('.candidate-portal__cv-creator .resume .pdf-data .actions .download').on('click', function(e) {
            $.psEmit('CV Creator CSAT Login', { onceKey: 'cv_login_' + "pdf_id" })
  .done(function () {
    console.info('[PageSense] emitido: CV Creator CSAT Login');
  })
  .fail(function () {
    console.warn('[PageSense] NO emitido (timeout o no listo)');
  });

        });
    }

});